module.exports = __webpack_public_path__ + "img/icon_copy.b2a3ea79.svg";